export const mobileWidth = 959;
export const phoneToTabletBreakPoint = 750;